module.exports = __webpack_public_path__ + "img/powerpoint.98166af6.png";